<template>
  <div class="box">
    <h2 class="title is-5 is-unselectable">
      Options/switches
    </h2>

    <div class="extrapadding">
      <CheckboxText
        v-if="(!isGroup && installable) || (isGroup && !isGroupAutoUpgrade)"
        :checked="hasParam(item.tempCommand.parameters, '-m')"
        @click="addTempParam(item, '-m')"
        tooltip="Allows multiple versions of a package"
        tooltipCss="has-tooltip-right"
        >Multiple versions (-m)</CheckboxText
      >

      <CheckboxText
        :checked="hasParam(item.tempCommand.parameters, '-n')"
        @click="addTempParam(item, '-n')"
        tooltip="Only adds/remove the package"
        tooltipCss="has-tooltip-right"
        >Add/remove package only (-n)</CheckboxText
      >

      <CheckboxText
        :checked="item.tempCommand.execAsUser"
        @click="addRunAsUser(item)"
      >
        <span
          data-tooltip="Run command as logged on (administrator) user"
          tooltipCss="has-tooltip-right"
          >Run as logged on user</span
        >
      </CheckboxText>

      <CheckboxText
        v-if="!isGroup"
        :checked="item.tempCommand.streamLog"
        @click="setStreamLog(item)"
      >
        <span
          data-tooltip="Command log updates in real-time"
          tooltipCss="has-tooltip-right"
          >Stream log</span
        >
      </CheckboxText>
    </div>
  </div>
</template>

<script>
import { hasParam } from "@/utils/mdc";
import { addTempParam } from "@/utils/packages";
import status from "@/utils/packageStatus";
import groupStatus from "@/utils/groupPackageStatus";

export default {
  components: {
    CheckboxText: () => import("@/components/singles/CheckboxText.vue"),
  },
  props: { item: Object, isGroup: Boolean },

  computed: {
    store() {
      if (this.isGroup) return "groupPackage";
      else return "computerPackage";
    },
    hasParam() {
      return (params, param) => {
        return hasParam(params, param);
      };
    },

    isGroupAutoUpgrade() {
      return groupStatus.isTempAutoUpgrade(this.item);
    },
    installable() {
      return status.isInstallable(this.item);
    },
    uninstallable() {
      return status.isUninstallable(this.item);
    },
  },
  methods: {
    addRunAsUser(item) {
      this.$store.commit(`${this.store}/editMergedPackage`, {
        p: this.item,
        obj: {
          tempCommand: {
            ...item.tempCommand,
            execAsUser: !item.tempCommand.execAsUser,
          },
        },
      });
    },

    addOverride(item) {
      this.$store.commit(`${this.store}/editMergedPackage`, {
        p: this.item,
        obj: {
          tempCommand: {
            ...item.tempCommand,
            override: !item.tempCommand.override,
          },
        },
      });
    },

    addTempParam(item, param) {
      const newParams = addTempParam(item.tempCommand.parameters, param);

      this.$store.commit(`${this.store}/editMergedPackage`, {
        p: this.item,
        obj: { tempCommand: { ...item.tempCommand, parameters: newParams } },
      });
    },

    setStreamLog(item, param) {
      this.$store.commit(`${this.store}/editMergedPackage`, {
        p: this.item,
        obj: {
          tempCommand: {
            ...item.tempCommand,
            streamLog: !item.tempCommand.streamLog,
          },
        },
      });
    },
  },
};
</script>
